import React, { useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import { checkUID } from "../../../ResuableCompoment/ValidateAadhar";

const PanAadhaarVerifyModal = ({ onClose, onSuccess }) => {
    const [pan, setPan] = useState("");
    const [aadhaar, setAadhaar] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);

    const { callApi: panaddharlink } = useApi(
        "/staff/onboard/pan-aadhaar-link",
        "POST"
    );

    const verifyLink = async () => {
        if (!pan || pan.length !== 10) {
            setMessage("Enter valid PAN number");
            setIsError(true);
            return;
        }

        // Aadhaar validation using checkUID
        if (!aadhaar || !checkUID(aadhaar)) {
            setMessage("Enter valid Aadhaar number");
            setIsError(true);
            return;
        }

        try {
            setLoading(true);
            setMessage("");

            const res = await panaddharlink(
                null,
                `?pan=${pan}&aadhaar=${aadhaar}`
            );

            if (res?.status === "success") {
                setMessage(res?.data?.message || "Verification successful");
                setIsError(false);

                setTimeout(() => {
                    onSuccess && onSuccess();
                }, 2000);
            } else {
                setMessage("PAN and Aadhaar are NOT linked");
                setIsError(true);
            }
        } catch (err) {
            setMessage("Verification failed");
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

            {/* Popup */}
            <div className="w-[50vw] max-w-[700px] rounded-xl bg-white p-8 shadow-xl">

                <h3 className="text-xl font-semibold text-[#0A2A4F] mb-6">
                    PAN Aadhaar Verification
                </h3>

                {/* PAN INPUT */}
                <div className="mb-4">
                    <label className="text-sm text-gray-600">PAN Number</label>
                    <input
                        value={pan}
                        onChange={(e) =>
                            setPan(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))
                        }
                        placeholder="ABCDE1234F"
                        className="w-full border rounded px-3 py-2 mt-1"
                    />
                </div>

                {/* AADHAAR INPUT */}
                <div className="mb-4">
                    <label className="text-sm text-gray-600">Aadhaar Number</label>
                    <input
                        value={aadhaar}
                        onChange={(e) =>
                            setAadhaar(e.target.value.replace(/\D/g, "").slice(0, 12))
                        }
                        placeholder="Enter Aadhaar number"
                        className="w-full border rounded px-3 py-2 mt-1"
                    />
                </div>

                {/* MESSAGE */}
                {message && (
                    <p
                        className={`text-sm mb-4 text-center font-medium ${isError ? "text-red-600" : "text-green-600"
                            }`}
                    >
                        {message}
                    </p>
                )}

                {/* BUTTONS */}
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded border text-gray-600"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={verifyLink}
                        disabled={loading}
                        className="px-6 py-2 rounded bg-[#0A2A4F] text-white"
                    >
                        {loading ? "Verifying..." : "Verify"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default PanAadhaarVerifyModal;